// fetchDateDisplay.component.js

import React from "react";
import ReplayIcon from "@mui/icons-material/Replay";

const formatTime = (date) => {
  if (!date) return "Never";

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const FetchDateDisplay = ({ lastFetchDate, handleGetFriendsList, isUserOnIos }) => {
  // const getNextUpdateDate = (date) => {
  //   if (!date) return null;
  //   const nextUpdate = new Date(date.getTime() + 60 * 60 * 1000);
  //   return nextUpdate;
  // };

  // const nextFetchDate = getNextUpdateDate(lastFetchDate);

  return (
    <div
      style={{
        position: "absolute",
        bottom: isUserOnIos ? "4rem" : "3rem",
        left: "1rem",
        maxWidth: "35rem",
        padding: "1rem",
        // paddingLeft: ".5rem",
        fontSize: "11px",
        backgroundColor: "#282c34",
        minWidth: "85vw",
      }}
    >
      <>
        last update: {formatTime(lastFetchDate)}
        {/* | next update:{" "}
        {formatTime(nextFetchDate)} |{" "} */}
        {/* <button
          style={{ padding: 0, marginLeft: "3px" }}
          onClick={handleGetFriendsList}
        >
          <ReplayIcon style={{ fontSize: "10px", padding: 0 }} />
        </button> */}
      </>
    </div>
  );
};

export default FetchDateDisplay;
